import Grid, { Column } from '@talkdesk/cobalt-react-grid'
import { Heading } from '@talkdesk/cobalt-react-typography'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'

const SettingItem = ({ title, actionButton, children }) => (
  <Grid columns='3' height='100%' width='100%'>
    <Column length={['3', '2', '2']}>
      <Flex as='header' padding={['3', '4', '6']}>
        <Flex grow paddingLeft='3'>
          <Heading level='4' scale='small'>
            {title}
          </Heading>
        </Flex>
        {actionButton && <Flex gap='3'>{actionButton}</Flex>}
      </Flex>
      <Box gap='6' padding={['3', '4', '6']}>
        {children}
      </Box>
    </Column>
  </Grid>
)

export default SettingItem
